import { APIVersion } from 'additiv-services';
import { getSetupData } from '../additiv-services/setup';

const setupData = getSetupData();

export const BASIC_API_URL = `${setupData.GATEWAY_API_URL}${setupData.CSL_URL_SUFFIX}`;

export const CUSTOM_SERVICE_LAYER_SERVICES = {
    CONTACT: 'Contact',
    CONTACTS: 'contacts',
    CASE_MANAGEMENT: 'CaseManagement',
    PLAN: 'plan',
    MEMBERS: 'members',
    INVESTMENT: 'investment',
    CONTACT_ACTIVATION: 'ContactActivation',
    DOCUMENTS: 'Documents',
    COMMON: 'common',
    ADVISORY: 'Advisory',
    CASE_ORDERS: 'case-orders',
    SYSTEM_MESSAGES: 'system-messages',
    BUNDLE_DOCUMENTS: 'bundle-documents',
    DEFAULT: '',
};
export const CREDIT_SERVICE_LAYER_SERVICES = {
    DEFAULT: '',
};

export const getCustomServiceLayerBaseUrl = (service, version = APIVersion.V10) => `${BASIC_API_URL}/${version}/${service}`;
